<template>
  <div>
    <div id="bg"></div>
    <div id="wrap">
      <ul class="blind">
        <li>
          <a href="#contents">본문 바로가기(Skip Contents)</a>
        </li>
      </ul>

      <SubHeaderWithSidebar :title="headerTitle" />
      <!-- //header -->

      <div id="container" ref="container">
        <section id="contents">
          <div class="nowRank">
            <div class="scoreWrap">
              <div class="left">
                <h6>SCORE</h6>
                <h5>현재</h5>
              </div>
              <div v-if="my_point >0" class="right">
                <span>{{my_rank}}</span>
                <b>위</b>
              </div>
              <div v-if="my_point === 0" class="right">
                <span>0</span>
                <b>위</b>
              </div>
            </div>
            <div class="icon">
              <img :src="rankImg" alt="1위" />
            </div>
            <div class="info">
              <ul>
                <li>
                  <h3 class="c_point">{{my_point}}</h3>
                  <p>나의 정답수</p>
                </li>
                <li>
                  <h3>{{avg_point}}</h3>
                  <p>평균 정답수</p>
                </li>
                <li>
                  <h3>{{st1_point}}</h3>
                  <p>1위 정답수</p>
                </li>
              </ul>
            </div>
          </div>
        </section>
        <!-- //contents -->
      </div>
      <!-- //container -->
    </div>
    <!-- //wrap -->
  </div>
</template>

<script>
import SubHeaderWithSidebar from "@/components/SubHeaderWithSidebar";
import sideMixin from "@/components/SideMixin";
export default {
  mixins: [sideMixin],
  components: { SubHeaderWithSidebar },
  computed: {
    my_rank() {
      return this.$store.state.itemMeta.my_rank;
    },
    my_point() {
      return this.$store.state.itemMeta.my_point;
    },
    avg_point() {
      return this.$store.state.itemMeta.avg_point;
    },
    st1_point() {
      return this.$store.state.itemMeta.st1_point;
    },
    headerTitle() {
      return this.$store.state.itemMeta.item_type === "quiz"
        ? "Live Quiz"
        : "Live Poll";
    },
    rankImg() {
      if (this.my_point === 0) {
        return require("@/assets/img/rank_3.png");
      } else {
        if (this.my_rank >= 10) {
          return require("@/assets/img/rank_1.png");
        } else if (this.my_rank >= 20) {
          return require("@/assets/img/rank_2.png");
        } else {
          return require("@/assets/img/rank_3.png");
        }
      }
    }
  }
};
</script>


<style lang="scss" scoped>
</style>